import React from "react";
import DiyRobot from "../../assets/kits-image.png";

const KitsSection = () => {
  return (
    <section className="bg-white py-10 sm:py-14 lg:py-16">
      <div className="mx-auto flex max-w-[1720px] flex-col items-center gap-8 px-4 sm:gap-10 sm:px-6 md:px-10 lg:flex-row lg:items-center lg:justify-between lg:gap-10 lg:px-14">
        <div className="w-full max-w-[875px]">
          <span className="inline-flex bg-[#923D8C] px-4 py-2 text-2xl font-bold leading-tight tracking-[1%] text-white sm:px-7 sm:py-3 sm:text-3xl sm:leading-[34px] md:text-4xl">
            Kits
          </span>

          <p className="mt-4 text-base text-justify tracking-[1%] text-black sm:mt-5 sm:text-lg md:text-xl">
            Our <span className="font-bold">DIY Kits</span> are complete
            hardware + curriculum packages that introduce students to
            electronics, coding, sensors, and real-world automation. These kits
            are age-specific and come in variations for beginners to advanced
            learners.
          </p>

          <p className="mt-4 text-base text-justify tracking-[1%] text-black sm:mt-[18px] sm:text-lg md:text-xl">
            Kits include pre-configured components such as Arduino boards, LEDs,
            motors, sensors, breadboards, and LCD displays. Paired with
            instructional videos, guided coding challenges, and hands-on project
            cards, they support self-paced and instructor-led learning.
          </p>

          <div className="mt-5 tracking-[1%] text-black">
            <h3 className="text-xl font-bold leading-7 sm:text-2xl">
              Variants
            </h3>
            <ul className="mt-3 list-disc space-y-1 pl-5 text-base sm:mt-4 sm:pl-6 sm:text-lg md:text-xl">
              <li>Arduino-Based DIY Robotics Kit</li>
              <li>LEGO-Compatible Robotics (EV3, WeDo 2.0, Spike Prime)</li>
              <li>Advanced IoT Robotics with Wi-Fi/Bluetooth integration</li>
            </ul>
          </div>

          <div className="mt-5 tracking-[1%] text-black sm:mt-6">
            <h3 className="text-xl font-bold leading-7 sm:text-2xl">
              Key Capabilities:
            </h3>
            <ol className="mt-3 list-decimal space-y-1 pl-5 text-base sm:mt-4 sm:pl-6 sm:text-lg md:text-xl">
              <li>
                Build circuits, autonomous bots, and sensor-based projects
              </li>
              <li>
                Integrate motor drivers, ultrasonic distance measurement, IR
                detection, temperature sensing
              </li>
            </ol>
          </div>
        </div>

        <div className="flex w-full max-w-[666px] shrink-0 justify-center lg:justify-end">
          <img
            src={DiyRobot}
            alt="DIY robotics kit"
            className="h-auto w-full max-w-full object-contain"
          />
        </div>
      </div>
    </section>
  );
};

export default KitsSection;
